
define('text!templates/appMain/privilegedMain/qm/facetedSearch/tooltips/tooltip.html',[],function () { return '<div>\n    <span data-bind="lString: &apos;search.filters.tooltipSelected&apos;"></span>\n    <ul class="filter-tooltip" data-bind="foreach: $data">\n        <li><span data-bind="text: $data"></span></li>\n    </ul>\n</div>';});

